import { render, staticRenderFns } from "./UploadDialog.vue?vue&type=template&id=deee1662&scoped=true&lang=pug&"
import script from "./UploadDialog.vue?vue&type=script&lang=ts&"
export * from "./UploadDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UploadDialog.vue?vue&type=style&index=0&id=deee1662&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deee1662",
  null
  
)

component.options.__file = "UploadDialog.vue"
export default component.exports